"use strict";
exports.__esModule = true;
var filter_1 = require("../../../filter");
//# sourceMappingURL=cold-article.js.map